/* eslint-disable */
import { IsSupportHls, OsType } from '../utils';
import { reportByImg, reportByRequest } from './utils';
import state from '~/assets/js/player/store/state';

const times = state.times;

const liveInfo = {
  siteid: '',
  platform: '',
  video_src: '',
  video_src_arr: [],
  ws_url: '',
  ws_url_arr: [],
  os: OsType,
  uid: '',
  roomid: '',
  alive: 0,
  hasChange: 0, // 是否切过流
  oldSiteid: '',
  oldPlatform: '',
  clientIp: '',
  clientIpFromServer: '',
  uidToken: '',
  restart: 0
};

// 上报hive
var reportToHive = (function() {
  if (!process.client) {
    return {
      reportClick: new Function,
      reportShare: new Function,
      reportTime: new Function,
      reportEnter: new Function,
      reportLeave: new Function,
      reportError: new Function,
      reportDebug: new Function
    }
  }

  var reportInfo = {
    countrycode: navigator.language,
    os: liveInfo.os,
    isplay: IsSupportHls,
    platform: '',
    owner_uid: function() {
      return liveInfo.uid;
    },
    result: function() {
      return liveInfo.alive;
    },
    from_app: function() {
      return liveInfo.platform || 'bigo';
    },
    timeStamp: function() {
      return Date.now();
    }
  };

  var getReportInfoStr = function () {
    var str = '';
    for (var k in reportInfo) {
      str += '&' + k + '='
      var info = reportInfo[k];
      if (typeof info === 'function') {
        str += info();
      } else {
        str += info
      }
    }
    return str;
  }

  var reportUrl = 'https://dotting.cube.tv/commonReporter/report';
  // var reportUrl = 'https://dotting.cube.tv/web_ci_index.php/CkReporter/report';

  var reportClick = function(n, options) {
    var url = reportUrl;
    url += '?event_id=018012004';
    url += getReportInfoStr();
    url += '&click=' + n;
    if (n === '6') {
      url += '&qxd=' + options.qxd;
      url += '&dw=' + options.dw;
    }
    reportByImg(url);
  };

  var reportShare = function(n) {
    var url = reportUrl;
    url += '?event_id=018012005';
    url += getReportInfoStr();
    url += '&click=' + n;
    reportByImg(url);
  };

  var reportTime = function() {
    var url = reportUrl;
    url += '?event_id=018012003';
    url += getReportInfoStr();
    url += '&t1=' + times.t1;
    url += '&t2=' + times.t2;
    url += '&t3=' + times.t3;
    url += '&t4=' + times.t4;
    url += '&t5=' + times.t5;

    var sourceLoadArr = performance.getEntries();
    for (var i = 0; i < sourceLoadArr.length; i++) {
      var this_source = sourceLoadArr[i];
      if (
        this_source.initiatorType === 'xmlhttprequest' &&
        this_source.name.slice(-3) === '.ts'
      ) {
        times.t6 =
          this_source.startTime.toFixed() -
          0 +
          performance.timing.navigationStart;
        times.t7 =
          this_source.responseEnd.toFixed() -
          0 +
          performance.timing.navigationStart;
        break;
      }
    }
    url += '&t6=' + times.t6;
    url += '&t7=' + times.t7;
    url += '&haschange=' + liveInfo.hasChange;
    url += '&restart=' + liveInfo.restart;
    url += '&cdnSrc=' + liveInfo.video_src;
    if (liveInfo.video_src) {
      url +=
        '&cdnHost=' + liveInfo.video_src.match(/(\w+):\/\/([^/:]+)(:\d*)?/)[2];
    }
    url += '&clientIp=' + liveInfo.clientIp;
    url += '&clientIpFromServer=' + liveInfo.clientIpFromServer;
    reportByImg(url);
  };

  var reportEnter = function(t) {
    var url = reportUrl;
    url += '?event_id=018012001';
    url += getReportInfoStr();
    url += '&staytime1=' + t;
    reportByImg(url);
  };

  var reportLeave = function(t) {
    var url = reportUrl;
    url += '?event_id=018012006';
    url += getReportInfoStr();
    url += '&staytime=' + t;
    reportByImg(url);
  };

  var reportError = function(type) {
    var url = reportUrl;
    url += '?event_id=018012008';
    url += getReportInfoStr();
    url += '&cdnSrc=' + liveInfo.video_src;
    if (liveInfo.video_src) {
      url +=
        '&cdnHost=' + liveInfo.video_src.match(/(\w+):\/\/([^/:]+)(:\d*)?/)[2];
    }
    url += '&clientIp=' + liveInfo.clientIp;
    url += '&errType=' + type;
    url += '&ua=' + navigator.userAgent;
    if (liveInfo.alive === 1) {
      reportByImg(url);
    }
  };

  var reportDebug = function(data) {
    var url = reportUrl;
    url += '?event_id=018012007&ext=1';
    url += getReportInfoStr();
    for (let k in data) {
      url += '&' + k + '=' + data[k];
    }
    if (liveInfo.alive === 1) {
      reportByRequest(url);
    }
  };

  return {
    reportClick: reportClick,
    reportShare: reportShare,
    reportTime: reportTime,
    reportEnter: reportEnter,
    reportLeave: reportLeave,
    reportError: reportError,
    reportDebug: reportDebug
  };
})();

export default reportToHive;
